import React from "react";
import "./CreateLoan.scss";
import { FormControlLabel, Paper, Radio, RadioGroup, styled, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from "@mui/material";
import { Button, Col, Row, Table } from "react-bootstrap";
import Utility from "../../utils/Utility";
import { columnMap, LOAN_STEPS, LOANS_WITH_TABLE_DATA, loanTypeLabelMap, PRODUCT_LOAN, PRODUCT_LOANS } from "./CreateLoanConstants";
import { Strings } from "../../resources/i18n/i18n";
import { colors } from "../../resources/styles/themes";
import moment from "moment";
import { CONFIGURATION_DATE_TIME_FORMAT, DEFAULT_VALUES, INVOICE_DATE_FORMAT, LOAN_APPLICATION_STATUS, SEARCH_FILTER_FIELDS, SEARCH_FILTER_TYPE } from "../../constants/appConstants";
import SearchFilter from "../CustomUIComponents/SearchFilter/SearchFilter";
import { DEFAULT_CATEGORY_SELECTION } from "../ProductCatalog/Constants";
import { LOAN_STATUS_CONSTANTS, LOAN_TYPES } from "../AnalystApproval/Constants";
import { DEFAULT_PAGINATION_ACTIVE_PAGE, DEFAULT_PAGINATION_RECORDS_COUNT } from "../CustomUIComponents/Pagination/PaginationConstants";
import Pagination from "../CustomUIComponents/Pagination/Pagination";
import CalculateEMIModal from "./CalculateEMIModal";
import { isEqual } from "lodash";
import CreditProductContainer from "../CreditProduct/CreditProductContainer";
import BasicInformationContainer from "../BasicInformation/BasicInfomationContainer";
import ReferencesContainer from "../References/ReferencesContainer";
import FinancialInformationContainer from "../FinancialInformation/FinancialInformationContainer";
import SiteVisitContainer from "../SiteVisit/SiteVisitContainer";
import EvidenceContainer from "../Evidence/EvidenceContainer";
import UserModal from "../CustomUIComponents/UserModal/UserModal";

class CreateLoan extends React.Component {
    constructor(props) {
        super(props);
        this.selectedLoanData = null;
        this.loanRecord = null;
        this.state = {
            errorMessage: "",
            calculateEMIModal: false,
            row: props.rows,
            loanApplicationFormData: {
                loanDetails: null,
                hasDisbursedLoan: false,
                createLoanButtonLabel: "",
                column: PRODUCT_LOAN,
                calculateEMI: {
                    EMIAmount: "",
                    frequency: this.props.frequencyList,
                },
                loanType: {
                    categoryList: props.productCategories ? props.productCategories : [],
                    productData: props.productData ? props.productData : [],
                    SearchFilter: {
                        productModel: "",
                        motorModel: "",
                        productCategory: "",
                        motorCategory: "",
                        activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
                        recordsPerPage: DEFAULT_PAGINATION_RECORDS_COUNT,
                    },
                    selectedLoanType: props.selectedLoanType,
                    selectedRecord: {},
                    selectedRecordData: "",
                    finalLoanApplicationId: "",
                },
            },
            showUserModal: false,
            modalMessage: "",
        };
    }

    componentDidUpdate(prevProps) {
        const { productCategories, selectedLoanType, lastDisbursedLoanDetails, activeStep } = this.props;
        if (productCategories && prevProps.productCategories !== productCategories) {
            let filterCategories = [...productCategories];

            if (filterCategories.length > 0 && filterCategories[0].id !== "") {
                filterCategories.unshift(DEFAULT_CATEGORY_SELECTION);
            }

            filterCategories = filterCategories.map(category => ({
                label: category.cat,
                value: Number(category.id),
            }));

            this.setState(prevState => ({
                loanApplicationFormData: {
                    ...prevState.loanApplicationFormData,
                    loanType: {
                        ...prevState.loanApplicationFormData.loanType,
                        categoryList: filterCategories,
                    },
                },
            }));
        }
        if (!isEqual(prevProps.selectedLoanType, selectedLoanType)) {
            this.setState(prevState => ({
                loanApplicationFormData: {
                    ...prevState.loanApplicationFormData,
                    loanType: {
                        ...prevState.loanApplicationFormData.loanType,
                        selectedRecord: {},
                        selectedRecordData: "",
                    },
                    calculateEMI: {
                        ...prevState.loanApplicationFormData.calculateEMI,
                        EMIAmount: "",
                    }
                },
            }));
        }
        if (
            prevProps.selectedLoanType !== selectedLoanType ||
            prevProps.lastDisbursedLoanDetails !== lastDisbursedLoanDetails
        ) {
            const hasDisbursedLoan = lastDisbursedLoanDetails.some(
                loan => loan.st === LOAN_APPLICATION_STATUS.disbursed
            );
            const selectedLoan = lastDisbursedLoanDetails.find(
                loan => loan.tp === selectedLoanType && loan.fd === null
            );

            const createLoanButtonLabel =
                selectedLoan && selectedLoan.st !== LOAN_APPLICATION_STATUS.disbursed
                    ? selectedLoan.st
                    : Strings("applyForLoan");

            this.setState((prevState) => ({
                loanApplicationFormData: {
                    ...prevState.loanApplicationFormData,
                    loanDetails: selectedLoan || null,
                    createLoanButtonLabel: createLoanButtonLabel,
                    hasDisbursedLoan: hasDisbursedLoan,
                }
            }));
        }
        if (activeStep === 0 && prevProps.activeStep !== 0) {
            this.props.getLastDisbursedLoanId();
        }
        if (
            prevProps.activeStep === 6 &&
            this.props.activeStep === 0
        ) {
            if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
                this.resetSelectedRecord();
                this.props.factoringLoanTypeAction();
                this.props.clearCreditProductInputDataForEditAction();
            } else {
                this.props.clearCreditProductInputDataForEditAction();
            }
        }

        if (prevProps.activeStep === 1 &&
            this.props.activeStep === 0 && this.props.selectedLoanType === LOAN_TYPES.FACTORING
        ) {
            this.props.factoringLoanTypeAction();
        }
    }
    renderTableData = (row, key) => {
        switch (key) {
            case 'img':
                return (
                    <img
                        src={row[key]}
                        alt={row.mn}
                        style={{ width: 120, height: 120, objectFit: "contain" }}
                    />
                );
            case 'select':
                let selectedRecordId = this.state.loanApplicationFormData.loanType.selectedRecord.id;
                let tableRowData = row.id;
                if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
                    selectedRecordId = this.state.loanApplicationFormData.loanType.selectedRecord?.number;
                    tableRowData = row.number
                }
                return (
                    <div>
                        <FormControlLabel
                            key={row[key]}
                            value={Strings(row.id)}
                            control={<Radio
                                checked={selectedRecordId === tableRowData}
                                onChange={() => this.handleSelectedData(row)}
                            />}
                            sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9rem' } }}
                        />
                    </div>
                );
            case 'date':
                return moment(row[key]).format(CONFIGURATION_DATE_TIME_FORMAT);
            case 'expiryDate':
                return moment(row[key]).format(CONFIGURATION_DATE_TIME_FORMAT);
            case "amount":
            case "co":
            case "cost":
                return Utility.getCurrencyRepresentationOfAmount(row[key]);

            case "category":
                return row[key].category;
            case "ProductPreservedData":
                return row[key].pn;
            case "productNameAndDescription":
                return row[key].productName;
            default:
                return row[key] ? Strings(row[key]) : Strings("NA");
        }
    }
    renderCustomDataGrid = (columns, rows) => {
        const StyledTableCell = styled(TableCell)(({ theme }) => ({
            [`&.${tableCellClasses.head}`]: {
                backgroundColor: "#e0e0e0",
                color: theme.palette.common.black,
                textAlign: 'center',
                position: 'sticky',
                top: 0,
                zIndex: 1,
            },
            [`&.${tableCellClasses.body}`]: {
                fontSize: 14,
                textAlign: 'center'
            }
        }))

        const StyledTableRow = styled(TableRow)(({ theme }) => ({
            "&:nth-of-type(even)": {
                backgroundColor: theme.palette.action.hover,
            },
            "&:last-child td, &:last-child th": {
                border: 0,
            },
        }))

        return (
            <div className='d-flex justify-content-center mx-3 mb-3'>
                <TableContainer
                    component={Paper}
                    className='d-flex justify-center'
                    style={{
                        maxHeight: '23rem',
                        overflowY: 'auto',
                    }}
                >
                    <Table stickyHeader aria-label='customized table'>
                        <TableHead>
                            <TableRow>
                                {columns.length > 0 &&
                                    columns.map((column) => (
                                        <StyledTableCell
                                            key={column.key}
                                            className='header'
                                            title={column.name}
                                        >
                                            <div>{column.name}</div>
                                        </StyledTableCell>
                                    ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {rows.map((row, rowIndex) => (
                                <StyledTableRow
                                    key={rowIndex}
                                    hover
                                    style={{ cursor: 'pointer' }}
                                >
                                    {columns.map((column) => (
                                        <StyledTableCell
                                            className={`text-break px-2`}
                                            key={column.key}
                                            component='th'
                                            scope='row'
                                            style={{
                                                maxWidth: column.maxWidth,
                                                minWidth: column.minWidth,
                                            }}
                                            title={
                                                column.key === "productNameAndDescription" &&
                                                    row[column.key].description
                                                    ? row[column.key].productName +
                                                    " " +
                                                    row[column.key].description
                                                    : column.key === "select" ? Strings("select")
                                                        : column.key === "img" ? row.mn
                                                            : this.renderTableData(row, column.key)
                                            }
                                        >
                                            <div
                                                className="text-break"
                                                style={{
                                                    color: colors.textColor20,
                                                    fontSize: 17,
                                                    fontFamily: 'Roboto-Regular',
                                                }}

                                            >
                                                {this.renderTableData(row, column.key)}
                                            </div>
                                        </StyledTableCell>
                                    ))}
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </div>
        );
    };
    renderSearchFilter = () => {
        let loanType = this.props.selectedLoanType;
        let catalogFilters = [
            {
                type: SEARCH_FILTER_TYPE.SELECTION,
                handleOnChange: this.props.handleFiltersChange,
                Value: loanType === LOAN_TYPES.CONSUMER ? this.props.loanTypeObj.SearchFilter?.productCategory
                    : this.props.loanTypeObj.SearchFilter?.motorCategory,
                inputType: SEARCH_FILTER_TYPE.NUMBER,
                filterDropdownList: this.state.loanApplicationFormData.loanType.categoryList,
                key: loanType === LOAN_TYPES.CONSUMER ? "productCategory" : "motorCategory",
            },
            {
                type: SEARCH_FILTER_TYPE.INPUT,
                fieldname: SEARCH_FILTER_FIELDS.MODEL,
                handleOnChange: this.props.handleFiltersChange,
                Value: loanType === LOAN_TYPES.CONSUMER ? this.props.loanTypeObj.SearchFilter?.productModel
                    : this.props.loanTypeObj.SearchFilter?.motorModel,
                key: loanType === LOAN_TYPES.CONSUMER ? "productModel" : "motorModel",
                searchPlaceHolder: Strings("model"),
            },
        ];

        return (
            <div className="pb-4">
                <SearchFilter
                    filters={catalogFilters}
                    handleOnClickSearchFilter={this.handleOnClickSearchFilter}
                    handleOnClickResetFilter={this.resetSearchValues}
                    paddingLeft={2}
                />
            </div>
        )
    }
    handleSelectedData = (selectedRecord) => {
        const { selectedLoanType } = this.props;
        let EMIAmount, selectedRecordData;

        switch (selectedLoanType) {
            case LOAN_TYPES.FACTORING:
                EMIAmount = selectedRecord?.amount;
                selectedRecordData = selectedRecord.number;
                break;

            case LOAN_TYPES.CONSUMER:
                EMIAmount = selectedRecord?.cost;
                selectedRecordData = selectedRecord.productNameAndDescription?.productName
                break;

            case LOAN_TYPES.MOTORCYCLE_LOAN:
                EMIAmount = selectedRecord?.co;
                selectedRecordData = selectedRecord?.mn
                break;

            default:
                EMIAmount = undefined;
        }
        this.setState((prevState) => ({
            errorMessage: "",
            loanApplicationFormData: {
                ...prevState.loanApplicationFormData,
                calculateEMI: {
                    ...prevState.loanApplicationFormData.calculateEMI,
                    EMIAmount,
                },
                loanType: {
                    ...prevState.loanApplicationFormData?.loanType,
                    selectedRecord,
                    selectedRecordData,
                }
            }
        }));
    };
    resetSelectedRecord = () => {
        this.setState((prevState) => ({
            loanApplicationFormData: {
                ...prevState.loanApplicationFormData,
                calculateEMI: {
                    ...prevState.loanApplicationFormData.calculateEMI,
                    EMIAmount: "",
                },
                loanType: {
                    ...prevState.loanApplicationFormData?.loanType,
                    selectedRecord: {},
                    selectedRecordData: "",
                }
            }
        }));
    }
    renderTable = () => {
        const columns = columnMap[this.props.selectedLoanType] || [];
        return (
            <Col>
                {
                    this.renderCustomDataGrid(
                        columns,
                        this.props.rows,
                    )
                }
            </Col>
        )
    }
    resetSearchValues = () => {
        this.setState({
            loanApplicationFormData: {
                ...this.state.loanApplicationFormData,
                loanType: {
                    ...this.state.loanApplicationFormData.loanType,
                    selectedRecord: {},
                }
            }
        });
        this.props.resetSearchFilters(() => {
            this.handleOnClickSearchFilter(true);
        });
    };
    handleOnClickSearchFilter = (isDeFaultOffset) => {
        isDeFaultOffset &&
            this.setState(prevState => ({
                loanApplicationFormData: {
                    ...prevState.loanApplicationFormData,
                    loanType: {
                        ...prevState.loanApplicationFormData.loanType,
                        SearchFilter: {
                            ...prevState.loanApplicationFormData.loanType.SearchFilter,
                            activePage: DEFAULT_PAGINATION_ACTIVE_PAGE,
                        },
                    },
                },
            }));
        const modelKey = this.props.selectedLoanType === LOAN_TYPES.CONSUMER ? "productModel"
            : "motorModel";
        const categoryKey = this.props.selectedLoanType === LOAN_TYPES.CONSUMER
            ? "productCategory"
            : "motorCategory";
        let modelValue = this.props.loanTypeObj.SearchFilter?.[modelKey];
        let categoryValue = this.props.loanTypeObj.SearchFilter?.[categoryKey];
        let searchFilterObject = {
            search: {
                model: modelValue !== "" ? modelValue : undefined,
                category: categoryValue !== "" && !DEFAULT_VALUES.includes(categoryValue) ? categoryValue : undefined,
                minimartId: this.props.minimart.minimartDetails.id
            },

            limit: this.props.loanTypeObj.SearchFilter?.recordsPerPage,
            offset: isDeFaultOffset
                ? DEFAULT_PAGINATION_ACTIVE_PAGE - 1
                : this.props.loanTypeObj.SearchFilter?.activePage - 1,
        };
        if (this.props.selectedLoanType === LOAN_TYPES.CONSUMER) {
            this.props.handleProductSearchFilter(
                searchFilterObject
            );
        } else if (this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
            this.props.handleMotoCycyleSearchFilter(
                searchFilterObject
            );
        }
    };
    onPageChange = ({ page, pageLength }) => {
        this.props.onPaginationChange({ page, pageLength }, () => {
            this.handleOnClickSearchFilter(false);
        });
    };

    renderCustomizedText = (mainText, showColon) => {
        return (
            <Col xs="auto" className="pb-2 d-flex align-items-center">
                <span className="createLoanSubHeadingText mb-0" style={{ fontSize: "1rem" }}>
                    {loanTypeLabelMap[this.props.selectedLoanType] || ''} {Strings(mainText)}
                </span>
                {showColon && <span className="createLoanSubHeadingText">&nbsp;:&nbsp;</span>}
            </Col>

        )
    }
    renderSelectedRecord = (loanDetails) => {
        let selectedRecord;
        if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
            selectedRecord = this.state.loanApplicationFormData.loanType.selectedRecord?.number ? this.state.loanApplicationFormData.loanType.selectedRecord?.number : this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed && this.props.existingLoanCreatedInvoice
        } else if (this.props.selectedLoanType === LOAN_TYPES.CONSUMER) {
            selectedRecord = this.state.loanApplicationFormData.loanType.selectedRecord?.productNameAndDescription?.productName ? this.state.loanApplicationFormData.loanType.selectedRecord?.productNameAndDescription?.productName : this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed && loanDetails?.pi?.nm;
        }
        else if (this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
            selectedRecord = this.state.loanApplicationFormData.loanType.selectedRecord?.mn ? this.state.loanApplicationFormData.loanType.selectedRecord?.mn : this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed && loanDetails?.pi?.nm
        }
        return (
            <span className="subHeaderApplication">
                {selectedRecord ? selectedRecord : LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) && Strings("NA")}
            </span>
        )
    }
    renderCalculateEMIModal = () => {
        const selectedRecord = this.state.loanApplicationFormData.loanType.selectedRecordData;
        if (!this.props.selectedLoanType) {
            this.setState({
                errorMessage: Strings("pleaseSelectLoanType")
            });
        }
        else if (!LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType)) {
            this.setState({
                calculateEMIModal: true,
            });
        }
        else if (
            !selectedRecord
        ) {
            this.setState({
                errorMessage: Strings("pleaseSelectRecord")
            });
        }
        else {
            this.setState({
                calculateEMIModal: true,
            });
        }
    }
    renderLoanTypes = () => {
        let eligibleLoantypes = this.props.eligibleLoantypes.map(item => ({
            label: Strings(item),
            value: item,
        }));
        return (
            <Row>
                <Col md={12}>


                    <RadioGroup
                        row
                        value={this.props.selectedLoanType || ""}
                        onChange={(event) => {
                            this.setState({ errorMessage: "" });
                            this.props.handleLoanTypeRadioChange?.(event);
                        }}
                    >
                        {eligibleLoantypes?.map((option, index) => (
                            <FormControlLabel
                                key={index}
                                value={option.value}
                                control={<Radio />}
                                label={option.label}
                                disabled={option.disable}
                                sx={{ '& .MuiFormControlLabel-label': { fontSize: '0.9rem', paddingRight: '1rem' } }}
                            />
                        ))}
                    </RadioGroup>
                </Col>
            </Row>
        )
    }
    validateData = () => {
        const selectedRecord = this.state.loanApplicationFormData.loanType.selectedRecordData;
        if (!this.props.selectedLoanType) {
            this.setState({
                errorMessage: Strings("pleaseSelectLoanType")
            });
        }
        else if (
            (LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) && !selectedRecord) && !(this.props.selectedLoanType !== LOAN_TYPES.FACTORING && this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed && this.props.selectedLoanType === this.state.loanApplicationFormData.loanDetails?.tp) && !(this.props.selectedLoanType === LOAN_TYPES.FACTORING && this.props.existingLoanCreatedAmount)
        ) {
            this.setState({
                errorMessage: Strings("pleaseSelectRecord")
            });
        }
        else {
            let loanDetails = [];
            this.props.lastDisbursedLoanDetails.map((loans) => {
                if (this.props.selectedLoanType === loans.tp) {
                    loanDetails = loans;
                }
                return loanDetails;
            })

            let loanApplicationId = loanDetails?.length !== 0 ? loanDetails.appId : this.props.lastDisbursedLoanId;
            if (this.props.selectedLoanType === LOAN_TYPES.FACTORING && this.props.factoringLoanApplicationId) {
                loanApplicationId = this.props.factoringLoanApplicationId;
            }

            this.setState(prevState => ({
                loanApplicationFormData: {
                    ...prevState.loanApplicationFormData,
                    loanType: {
                        ...prevState.loanApplicationFormData.loanType,
                        finalLoanApplicationId: loanApplicationId,
                    },
                },
            }), () => {
                this.props.getLoanApplicationDetails(
                    this.state.loanApplicationFormData.loanType.finalLoanApplicationId,
                    loanDetails?.st
                )
            });

        }
    }
    getAmount = () => {
        if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
            return this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed ? this.props.existingLoanCreatedAmount : null;
        } else if (!PRODUCT_LOANS.includes(this.props.selectedLoanType)) {
            return this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed ? this.state.loanApplicationFormData.loanDetails?.apAmt : null
        } else {
            return this.state.loanApplicationFormData.loanDetails?.st !== LOAN_APPLICATION_STATUS.disbursed ? this.state.loanApplicationFormData.loanDetails?.pi?.co : null
        }
    }
    renderDisbursedLoanData = (loanDetails) => {
        return (
            <Col md={12}>
                <Row>
                    <span className="createLoanSubHeadingText mb-0 ps-0 pb-2 ">
                        {Strings("RequestFor") + "  " + loanDetails?.tp}
                    </span>

                </Row>
                <Row>
                    <Col md={6} className="ps-0">
                        <span className="p-0 ">
                            {loanDetails?.pi?.nm}
                        </span>
                    </Col>
                    <Col md={3} className="ps-0">
                        <span className="p-0 ">
                            {Strings("From")} &nbsp;:&nbsp; {moment(loanDetails?.fd).format(INVOICE_DATE_FORMAT)}
                        </span>
                    </Col>
                    <Col md={3} className="ps-0">
                        <span className="p-0 ">
                            {Strings("To")} &nbsp;:&nbsp; {moment(loanDetails?.td).format(INVOICE_DATE_FORMAT)}
                        </span>
                    </Col>
                </Row>
                <hr className="opacity-100 pb-2" />
            </Col>
        )
    }
    renderSelectedRecordData = (createLoanButtonLabel, amount, renderAmountLabel) => {
        let productnamme;
        if (this.props.selectedLoanType === LOAN_TYPES.CONSUMER) {
            productnamme = Strings("product")
        } else if (this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
            productnamme = Strings("motorcycle")
        } else if (this.props.selectedLoanType === LOAN_TYPES.FACTORING) {
            productnamme = Strings("invoice")
        }
        return (
            <Col md={12}>
                <Row className="align-items-center">
                    <Col md={6} className="ps-0">
                        {LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) && <Row>
                            <Col md={12} className="ps-0 pb-3">
                                <span className="createLoanSubHeadingText ps-0 pb-2 ">
                                    {Strings("selectRecord").replace("$", productnamme)}
                                </span>
                            </Col>
                        </Row>}
                        {<div className="d-flex flex-column gap-1">
                            <div className="d-flex align-items-center flex-wrap">
                                {LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) &&
                                    this.renderCustomizedText("selected", true)}
                                {this.renderSelectedRecord(this.state.loanApplicationFormData.loanDetails)}
                            </div>

                            {(renderAmountLabel || LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType)) && (
                                <div>
                                    <span className="createLoanSubHeadingText mb-0" style={{ fontSize: "1rem" }}>
                                        {Strings("amount")}<span>&nbsp;:&nbsp;</span>
                                    </span>
                                    <span>
                                        {amount ? " $" + Utility.getCurrencyRepresentationOfAmount(amount) : LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) && Strings("NA")}
                                    </span>
                                </div>
                            )}
                        </div>}
                    </Col>
                    <Col md={6} className="d-flex align-items-center justify-content-end">
                        <div className="d-flex gap-2">
                            {(this.props.selectedLoanType && this.props.selectedLoanType !== LOAN_TYPES.FAST_CASH) && (
                                <Button className="buttonBackground" onClick={this.renderCalculateEMIModal}>
                                    {Strings("calculateEmi")}
                                </Button>
                            )}
                            <Button
                                className="buttonBackground"
                                onClick={this.validateData}
                            >
                                {createLoanButtonLabel}
                            </Button>
                        </div>
                    </Col>
                </Row>
                <hr className="opacity-100 pb-2" />
            </Col>
        )
    }
    renderErrors = () => {
        return (
            <Row>
                <span className="p-0 errorText">
                    {this.state.errorMessage}
                </span>
            </Row>
        )
    }
    renderExistingLoanDetail = () => {
        let InfoText, productnamme;
        if (this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.CONSUMER || this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.MOTORCYCLE_LOAN) {
            this.loanRecord = this.props.existingSelectedLoanDetail?.pi?.nm;
            if (this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.CONSUMER) {
                productnamme = Strings("product")
            } else if (this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.MOTORCYCLE_LOAN) {
                productnamme = Strings("motorcycle")
            }
        } else if (this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.FACTORING) {
            this.loanRecord = this.props.existingSelectedLoanDetail?.number;
            productnamme = Strings("invoice")
        }
        InfoText = Strings("showExistingLoanDetail").replace("#", Strings(this.props.existingSelectedLoanDetail?.st)).replace("*", "$" + Utility.getCurrencyRepresentationOfAmount(this.props.existingSelectedLoanDetail?.apAmt))
        if (this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.FACTORING || this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.CONSUMER || this.props.existingSelectedLoanDetail?.tp === LOAN_TYPES.MOTORCYCLE_LOAN) {
            InfoText += " " + Strings("for") + " " + productnamme + " " + this.loanRecord;
        }
        return (
            <Col md={12} className="d-flex justify-content-between align-items-center">
                <Row>
                    <span className="createLoanSubHeadingText mb-0 ps-0 pb-2 ">
                        {InfoText}
                    </span>
                </Row>
                {this.props.existingSelectedLoanDetail?.st === LOAN_APPLICATION_STATUS.created && <Row>
                    <Button
                        className="buttonBorder"
                        onClick={() => {
                            this.setState({
                                showUserModal: true,
                                modalMessage: Strings("DismissLoanLoan"),
                            })
                        }}
                    >
                        {Strings("dismissLoan")}
                    </Button>
                </Row>}
            </Col>
        )
    }
    renderConfirmationModal = () => {
        let modalText1 = this.state.modalMessage || "";
        let headerText = Strings("dismissLoanConfirmation");
        return (
            <UserModal
                open={this.state.showUserModal}
                modalCloseOnEsc={false}
                modalCloseOnOverlayClick={false}
                modalShowCloseIcon={false}
                headerText={headerText}
                modalText1={modalText1}
                modalButtonOk={{
                    text: Strings("Proceed"),
                    onClick: () => this.props.updateLoanStatus(this.closeUserModal),
                }}
                modalButtonCancel={{
                    text: Strings("Cancel"),
                    onClick: this.closeUserModal,
                }}
                showHr={true}
            />
        )
    }
    closeUserModal = () => {
        this.setState({
            showUserModal: false,
            modalMessage: ""
        });
    }
    renderNoRecordFound = () => {
        if (this.props.selectedLoanType === LOAN_TYPES.FACTORING && !this.props.singleMiniMartDetails.minimartDetails.code) {
            return (
                <div className="warningText pb-3">{Strings("nonCiMinimartLoanNotAllowed")}</div>
            )
        }
        else {
            return (
                <div className="noRecordsFound">{Strings("NoRecordsFound")}</div>
            )
        }
    }
    renderLoanTypeStep = () => {
        let loanDetails = [];
        let createLoanButtonLabel = Strings("applyForLoan")
        this.props.lastDisbursedLoanDetails.map((loans) => {
            if (this.props.selectedLoanType === loans.tp) {
                loanDetails = loans;
                this.selectedLoanData = loans;
                if (loans.st && loans.st !== LOAN_APPLICATION_STATUS.disbursed) {
                    if (loans.st === LOAN_APPLICATION_STATUS.created) {
                        createLoanButtonLabel = Strings("loanApplication")
                    } else {
                        createLoanButtonLabel = Strings(loans.st);
                    }
                }
            }
            return loanDetails;
        })
        let renderAmountLabel = this.state.loanApplicationFormData.loanDetails?.tp === LOAN_TYPES.EXTERNAL_FACTORING
        let loanTypeWiseAmount = this.getAmount();

        let amount = this.state.loanApplicationFormData.calculateEMI.EMIAmount ? this.state.loanApplicationFormData.calculateEMI.EMIAmount : loanTypeWiseAmount;
        let isExistingLoanDetail = (this.props.existingSelectedLoanDetail?.st === LOAN_APPLICATION_STATUS.disbursed || !this.props.existingSelectedLoanDetail)
        return (
            <Col>
                <Row className="pb-2">
                    {this.state.errorMessage && this.renderErrors()}
                    <Col md={12}>
                        <Row className="p-0">
                            <span className="createLoanSubHeadingText p-0">{Strings("selectLoanType")} &nbsp;:&nbsp;</span>
                        </Row>
                    </Col>
                    <Col className="align-items-center p-0">
                        {this.renderLoanTypes()}
                        <hr className="opacity-100" style={{ marginLeft: "0.8rem", marginRight: "0.8rem" }} />
                    </Col>
                    {!isExistingLoanDetail && this.renderExistingLoanDetail()}
                    {!isExistingLoanDetail && <Col md={12}>
                        <hr className="opacity-100 pb-2 mt-3" />
                    </Col>}
                    {loanDetails?.st === LOAN_APPLICATION_STATUS.disbursed && PRODUCT_LOANS.includes(loanDetails?.tp) && this.renderDisbursedLoanData(loanDetails)}
                    {isExistingLoanDetail && this.renderSelectedRecordData(createLoanButtonLabel, amount, renderAmountLabel)}
                    <Col md={12}>
                        {isExistingLoanDetail && LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) && this.renderCustomizedText("list", false)}
                        {isExistingLoanDetail && (this.props.selectedLoanType === LOAN_TYPES.CONSUMER ||
                            this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) &&
                            this.renderSearchFilter()}
                    </Col>
                    {isExistingLoanDetail && LOANS_WITH_TABLE_DATA.includes(this.props.selectedLoanType) && (
                        <>
                            <Col md={12}>
                                {this.props.rows?.length > 0 ? (
                                    this.renderTable()
                                ) : (
                                    this.renderNoRecordFound()
                                )}
                            </Col>

                            {this.props.rows?.length > 0 && (this.props.selectedLoanType !== LOAN_TYPES.FACTORING) && (
                                <Col md={12} className="pt-3">
                                    <Pagination
                                        activePage={this.props.loanTypeObj.SearchFilter.activePage}
                                        recordsPerPage={this.props.loanTypeObj.SearchFilter.recordsPerPage}
                                        numberOfPages={this.props.numberOfPages}
                                        onPageChange={this.onPageChange}
                                        dropup={true}
                                    />
                                </Col>
                            )}
                        </>
                    )}
                    <Col md={12} className="d-flex justify-content-between">
                        <Button
                            className='buttonBorder me-4'
                            onClick={this.props.goBack}
                        >
                            {Strings("Back").toUpperCase()}
                        </Button>
                        {!isExistingLoanDetail && <Button
                            className='buttonBackground'
                            onClick={this.validateData}
                            disabled={false}
                        >
                            {Strings("Next").toUpperCase()}
                        </Button>}
                    </Col>
                </Row>
            </Col>
        );
    };

    renderCreditProducts = (disableTextField) => {
        let loanTypeWiseAmount = !PRODUCT_LOANS.includes(this.props.selectedLoanType) ? this.state.loanApplicationFormData.loanDetails?.apAmt : this.state.loanApplicationFormData.loanDetails?.pi?.co
        let amount = this.state.loanApplicationFormData.calculateEMI.EMIAmount ? this.state.loanApplicationFormData.calculateEMI.EMIAmount : loanTypeWiseAmount;

        if (this.props.selectedLoanType === LOAN_TYPES.MOTORCYCLE_LOAN) {
            let loanAmount = ((amount / 100) * 85).toFixed(2);
            amount = Math.ceil(loanAmount)
        }
        if (this.props.selectedLoanType === LOAN_TYPES.FACTORING && this.props.existingLoanCreatedAmount) {
            amount = this.props.existingLoanCreatedAmount;
        }
        return (
            <CreditProductContainer
                selectedLoanType={this.props.selectedLoanType}
                showLoadingModal={this.props.showLoadingModal}
                closeLoadingModal={this.props.closeLoadingModal}
                disableTextField={disableTextField}
                selectedRecordData={this.state.loanApplicationFormData.loanType.selectedRecordData || this.loanRecord}
                selectedRecordDetails={this.state.loanApplicationFormData.loanType.selectedRecord}
                EMIAmount={amount}
                existingLoanDetails={this.state.loanApplicationFormData.loanDetails}
                loanApplicationDetails={this.props.loanApplicationDetails}
                suggestedAmount={this.props.suggestedAmount}
                handleNext={this.props.handleNext}
                handleBack={this.props.handleBack}
                getLastDisbursedLoanId={this.props.getLastDisbursedLoanId}
                getLoanApplicationDetails={this.props.getLoanApplicationDetails}
                handleFieldChange={this.handleFieldChange}
                activeStep={this.props.activeStep}
                existingLoanCreatedInvoice={this.props.existingLoanCreatedInvoice}
                hasDisbursedLoan={this.state.loanApplicationFormData.hasDisbursedLoan}
                showLoadingModalState={this.props.showLoadingModalState}
            />
        )

    };

    renderBasicInfomation = (basicInformationLists, disableTextField) => {
        let dropDownList = basicInformationLists;
        return (
            <BasicInformationContainer
                selectedLoanType={this.props.selectedLoanType}
                showLoadingModal={this.props.showLoadingModal}
                closeLoadingModal={this.props.closeLoadingModal}
                dropdownValues={dropDownList}
                loanApplicationDetails={this.props.loanApplicationDetails}
                handleNext={this.props.handleNext}
                handleBack={this.props.handleBack}
                disableTextField={disableTextField}
                showLoadingModalState={this.props.showLoadingModalState}
            />
        )
    }

    renderReferences = (disableTextField) => {
        return (
            <ReferencesContainer
                selectedLoanType={this.props.selectedLoanType}
                showLoadingModal={this.props.showLoadingModal}
                closeLoadingModal={this.props.closeLoadingModal}
                loanApplicationDetails={this.props.loanApplicationDetails}
                handleNext={this.props.handleNext}
                handleBack={this.props.handleBack}
                disableTextField={disableTextField}
                invalidFormField={this.props.invalidFormField}
                showLoadingModalState={this.props.showLoadingModalState}
            />
        )
    }
    renderFinancialInformation = (financialInfoList, expensesLists, disableTextField) => {
        return (
            <FinancialInformationContainer
                financialInfoList={financialInfoList}
                expensesLists={expensesLists}
                loanApplicationDetails={this.props.loanApplicationDetails}
                handleNext={this.props.handleNext}
                handleBack={this.props.handleBack}
                showLoadingModal={this.props.showLoadingModal}
                closeLoadingModal={this.props.closeLoadingModal}
                disableTextField={disableTextField}
                showLoadingModalState={this.props.showLoadingModalState}
                selectedLoanType={this.props.selectedLoanType}
            />
        )
    }
    renderSiteVisit = (siteVisitList, disableTextField) => {
        return (
            <SiteVisitContainer
                siteVisitList={siteVisitList}
                loanApplicationDetails={this.props.loanApplicationDetails}
                handleNext={this.props.handleNext}
                handleBack={this.props.handleBack}
                showLoadingModal={this.props.showLoadingModal}
                closeLoadingModal={this.props.closeLoadingModal}
                disableTextField={disableTextField}
                invalidFormField={this.props.invalidFormField}
                showLoadingModalState={this.props.showLoadingModalState}
            />
        )
    }
    renderEvidence = (disableTextField) => {
        return (
            <EvidenceContainer
                selectedLoanType={this.props.selectedLoanType}
                loanApplicationDetails={this.props.loanApplicationDetails}
                handleNext={this.props.handleNext}
                handleBack={this.props.handleBack}
                showLoadingModal={this.props.showLoadingModal}
                closeLoadingModal={this.props.closeLoadingModal}
                finalLoanApplicationId={this.state.loanApplicationFormData.loanType.finalLoanApplicationId}
                disableTextField={disableTextField}
                redirectToLoanTypeStep={this.props.redirectToLoanTypeStep}
                showLoadingModalState={this.props.showLoadingModalState}
            />
        )
    }
    renderStepContent = (step) => {
        let disableTextField = false;
        const getListByType = (type) => {
            const item = this.props.dropdownValues.find(list => list.ft === type);
            return item ? item.ff : [];
        };
        if (this.selectedLoanData) {
            if (this.props.selectedLoanType === this.selectedLoanData.tp && (this.selectedLoanData.st === LOAN_STATUS_CONSTANTS.INPROCESS_ANALYSIS || this.selectedLoanData.st === LOAN_STATUS_CONSTANTS.INPROCESS_OPERATIONS || this.selectedLoanData.st === LOAN_STATUS_CONSTANTS.READY_FOR_COLLECTION)) {
                disableTextField = true;
            }

        }
        const basicInformationLists = getListByType(LOAN_STEPS.BASIC_INFORMATION);
        const financialInfoLists = getListByType(LOAN_STEPS.INCOME);
        const expensesLists = getListByType(LOAN_STEPS.EXPENSES);
        const siteVisitLists = getListByType(LOAN_STEPS.SITE_VISIT);
        switch (step) {
            case 0:
                return this.renderLoanTypeStep();
            case 1:
                return this.renderCreditProducts(disableTextField);
            case 2:
                return this.renderBasicInfomation(basicInformationLists, disableTextField);
            case 3:
                return this.renderReferences(disableTextField);
            case 4:
                return this.renderFinancialInformation(financialInfoLists, expensesLists, disableTextField);
            case 5:
                return this.renderSiteVisit(siteVisitLists, disableTextField);
            case 6:
                return this.renderEvidence(disableTextField)
            default:
                return Strings("unknownStep");
        }
    }
    onClosModal = () => {
        this.setState({
            calculateEMIModal: false,
        })
    }

    showCalculateEMIModal = () => {
        return (
            <CalculateEMIModal
                open={this.state.calculateEMIModal}
                modalHeader={Strings("CalculateEMI")}
                toggleModal={this.onClosModal}
                loanType={this.props.selectedLoanType}
                calculateEMIData={this.state.loanApplicationFormData.calculateEMI}
                getFrequencyList={this.props.getFrequencyList}
                minimart={this.props.minimart}
                isHistory={this.props.isHistory}
            />
        )
    }
    render() {

        return (
            <div className="calculateEMIModal">
                {this.state.calculateEMIModal && this.showCalculateEMIModal()}
                {this.state.showUserModal && this.renderConfirmationModal()}
                <Row className="createLoanContainer">
                    {this.renderStepContent(this.props.activeStep)}
                </Row>
            </div>
        );
    }
}
export default CreateLoan;